import React, { FC, ReactNode } from 'react'

import styled from 'styled-components'

import TrackCoverIcon from 'src/Assets/Svg/pages-icons/TrackCover.svg'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import SpotifyIcon from 'src/Assets/Svg/platform-icons/Spotify.svg?react'
import TikTokIcon from 'src/Assets/Svg/platform-icons/TikTok.svg?react'
import ReelsIcon from 'src/Assets/Svg/platform-icons/Reels.svg?react'
import MetaAdsIcon from 'src/Assets/Svg/platform-icons/meta-ads.svg?react'
import {
  CampaignPlatformTypeEnum,
  SpotifyCampaignMatchingType,
} from 'src/Types/campaigns'

import { SmartImage } from '../SmartImage'
import { PrimaryLabel } from '../PrimaryLabel'
import { ManualMatchingLabel } from '../ManualMatchingLabel'
import { PreReleaseLabel } from '../PreReleaseLabel'

import { ScheduleSettingsHeaderProps } from '.'

const TrackDetails = styled.div`
  display: flex;
  min-height: 70px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
  }
`

const TrackCover = styled(SmartImage)`
  width: 68px;
  height: 68px;
  border-radius: 16px;
`
const TrackInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`
const TrackSubInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`

const LabelsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`

const ArtistName = styled.div`
  color: ${(props) => props.theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
const TrackName = styled(ArtistName)`
  font-weight: 600;
`

const platformIconMap: Partial<Record<CampaignPlatformTypeEnum, ReactNode>> = {
  [CampaignPlatformTypeEnum.SPOTIFY]: <SpotifyIcon />,
  [CampaignPlatformTypeEnum.TIKTOK]: <TikTokIcon />,
  [CampaignPlatformTypeEnum.REELS]: <ReelsIcon />,
  [CampaignPlatformTypeEnum.META]: <MetaAdsIcon width={16} height={16} />,
}
const platformTextMap: Partial<Record<CampaignPlatformTypeEnum, ReactNode>> = {
  [CampaignPlatformTypeEnum.SPOTIFY]: 'Spotify',
  [CampaignPlatformTypeEnum.TIKTOK]: 'TikTok',
  [CampaignPlatformTypeEnum.REELS]: 'Reels',
  [CampaignPlatformTypeEnum.META]: 'Meta Ads',
}

type Props = Pick<
  ScheduleSettingsHeaderProps,
  | 'artistName'
  | 'platform'
  | 'trackCover'
  | 'trackName'
  | 'matchingType'
  | 'isPreRelease'
>

export const ScheduleSettingsHeaderTrackDetails: FC<Props> = (props) => {
  const {
    trackCover,
    platform,
    artistName,
    trackName,
    matchingType,
    isPreRelease,
  } = props
  const isManualMatchedCampaign =
    matchingType === SpotifyCampaignMatchingType.MANUAL
  const isPreReleaseVisible =
    Boolean(isPreRelease) && platform === CampaignPlatformTypeEnum.SPOTIFY
  return (
    <TrackDetails>
      <TrackCover
        width={68}
        height={68}
        src={trackCover}
        alt='track cover'
        fallbackSrc={TrackCoverIcon}
      />
      <TrackInfo>
        <TrackSubInfo>
          <TrackName>{trackName}</TrackName>
          <ArtistName>{artistName}</ArtistName>
        </TrackSubInfo>
        <LabelsWrapper>
          <PrimaryLabel text={platformTextMap[platform]}>
            {platformIconMap[platform]}
          </PrimaryLabel>
          {isPreReleaseVisible && <PreReleaseLabel />}
          {isManualMatchedCampaign && <ManualMatchingLabel />}
        </LabelsWrapper>
      </TrackInfo>
    </TrackDetails>
  )
}
